<div class="select selectSearch" [ngClass]="{'focus': focus, 'error': msgError!=null && msgError!='', 'readonly':readonly}">
    <input #inputSearch type="text"
        (focus)="focusEv()" 
        (focusout)="focusoutEv()" 
        [ngClass]="value?'full':''" 
        class="selectSearch"
        [readonly]="readonly"
        [value]="listDisplay? (value[listDisplay]? value[listDisplay] : '') : (value? value : '')"
        [disabled]="disabled"
        />
    <label>{{label}}</label>
    <span>{{msgError}}</span>
    <i class="fa fa-search"></i>
    <div class="data selectSearch" *ngIf="list.length>0">
        <ul class="selectSearch">
            <li class="selectSearch" *ngFor="let item of list" (click)="selectItem(item)">{{listDisplay? item[listDisplay] : item}}</li>
        </ul>
    </div>
</div>